define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function default_1(func, wait, immediate) {
        var pending = undefined;
        var _immediate = immediate;
        return function () {
            if (pending === undefined) {
                pending = arguments;
                if (_immediate) {
                    func.apply(null, arguments);
                }
                setTimeout(function () {
                    if (!_immediate) {
                        func.apply(null, pending);
                    }
                    pending = undefined;
                }, wait);
            }
        };
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/debounce.js
// module id = 33
// module chunks = 0